module.exports = __webpack_public_path__ + "207530a57b1db959ed11db454b297ab2.svg";